import { GLTFLoader } from './GLTFLoader';
import { TextureLoader } from 'three';

export const gltf = new GLTFLoader();

export const texture = new TextureLoader();


